import createReactContext from '@ant-design/create-react-context';
export var FormContext = createReactContext({
  labelAlign: 'right',
  vertical: false
});


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/form/context.js
// module id = 381
// module chunks = 14